<template>
  <a-modal
    :visible="ShowPanel" :mask="false" width="50%"
    title="新增数据"
    @ok="handleOk()"
    @cancel="handleCancel()">
    <a-form>
      <a-form-item label="文件" :label-col="{ span: 7 }" :wrapper-col="{ span: 12 }">
        <a-upload
          style="float: left"
          v-model:file-list="fileList"
          name="file"
          :showUploadList="false"
          :customRequest="customRequestSelf"
        >
          <a-button>上传</a-button>
        </a-upload>
        <span @click="downloadExample()"
              style="margin-left: 10px;cursor: pointer;font-size: 12px;color: #555555">下载实例文件</span>
      </a-form-item>
      <a-form-item label="日期" :label-col="{ span: 7 }" :wrapper-col="{ span: 6 }">
        <a-date-picker
          style="width: 200px;"
          v-model="addForm.date"
          valueFormat="YYYY-MM-DD"/>
      </a-form-item>
      <a-form-item label="渠道" :label-col="{ span: 7 }" :wrapper-col="{ span: 6 }">
        <a-select style="width: 200px" v-model="addForm.channel"
                  show-search
                  optionFilterProp="label" placeholder="请选择渠道">
          <a-select-option v-if="channelItem.status==1" :label="channelItem.name"
                           :key="channelItem.channel" :value="channelItem.channel"
                           v-for="channelItem in ChannelList">
            {{ channelItem.name }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="国家" :label-col="{ span: 7 }" :wrapper-col="{ span: 6 }">
        <a-select style="width: 200px" v-model="addForm.country" allowClear
                  @change="changeCountry()" optionFilterProp="label"
                  mode="multiple" :maxTagCount="1" placeholder="请选择国家">
          <a-select-option key="ALL" value="ALL" label="全部">
            全部
          </a-select-option>
          <a-select-option :key="countryItem.value" :value="countryItem.value"
                           :label="countryItem.name"
                           v-for="countryItem in $store.state.Country">
            {{ countryItem.name }}
          </a-select-option>
        </a-select>
      </a-form-item>
    </a-form>
    <a-table :columns="tableColumns3"
             style="flex: 1;overflow-y: hidden;background: #ffffff"
             :scroll="{ x: '500px'}" :data-source="Object.values(addForm.country_list)"
             :rowKey="item=>item.country"
             bordered :pagination="false">
      <template slot="spend" slot-scope="text,recode">
        <a-input-number v-model="addForm.country_list[recode.country]['spend']"></a-input-number>
      </template>
      <template slot="installs" slot-scope="text,recode">
        <a-input-number v-model="addForm.country_list[recode.country]['installs']"></a-input-number>
      </template>
      <template slot="action" slot-scope="text,recode">
        <a-button type="danger" size="small" ghost @click="removeCountry(text.country)">移除</a-button>
      </template>
    </a-table>
  </a-modal>
</template>

<script>
import {AddSpendSelf} from "../../../api/v1/spend_self_api";

export default {
  name: "AddPanel",
  props: ['ShowPanel', 'ChannelList'],
  data() {
    return {
      fileList: [],
      addForm: {
        channel: '',
        date: '',
        country: [],
        country_list: {}
      },
      tableColumns3: [
        {title: '国家', dataIndex: 'country', align: 'center'},
        {title: '花费', dataIndex: 'spend', scopedSlots: {customRender: 'spend'}, align: 'center'},
        {title: '安装', dataIndex: 'installs', scopedSlots: {customRender: 'installs'}, align: 'center'},
        {title: '操作', key: 'action', scopedSlots: {customRender: 'action'}, align: 'center'},
      ],
    }
  },
  watch: {
    'ShowPanel': {
      handler: function (newVal, oldVal) {
        this.addForm = {
          channel: '',
          date: '',
          country: [],
          country_list: {},
          app_id: this.$store.getters.getAppId
        }
      }
    }
  },
  methods: {
    customRequestSelf(options) {
      const {onSuccess, onError, file, onProgress} = options;
      let reader = new FileReader()
      let that = this
      reader.onload = function (event) {
        let fileContent = event.target.result
        fileContent = fileContent.replaceAll('"=""', "")
        fileContent = fileContent.replaceAll('"""', "")
        fileContent = fileContent.replaceAll('\r', "")
        let rows = fileContent.split("\n")
        rows.shift()
        let insertData = {}
        rows.forEach(item=> {
          if(item!=""){
            let itemData = item.split(",")
            let _key = itemData[0]+"-"+itemData[1]+"-"+itemData[2]
            if (!insertData[_key]){
              insertData[_key] = {
                app_id:itemData[0],
                date:itemData[1],
                channel:itemData[2],
                country_list:[],
              }
            }
            insertData[_key].country_list.push({
              country:itemData[3],
              spend:itemData[4],
              installs:itemData[5],
            })
          }
        })
        Object.values(insertData).forEach(insertItem=>{
          AddSpendSelf(insertItem).then(resp => {
            if (resp.code === 200) {
              that.$message.success(resp.msg)
            } else {
              that.$message.error(resp.msg)
            }
          })
          that.$emit('close-dialog')
        })
        // let data = rows.map(row => row.split(","))
        // console.log(data)
        onProgress({percent: 100}, null)
        onSuccess({code: 200, file: file}, null);
      };
      reader.readAsText(file);
    },
    downloadExample() {
      let _name = '消耗本地化维护案例'
      let _data_list = [
        {
          "app_id": "200",
          "date": "2024-01-01",
          "channel": "Test",
          "country": "ALL",
          "spend": 0,
          "install": 0
        }
      ]
      let _data_field = [
        {
          dataIndex: 'app_id',
          title: '应用编号'
        },
        {
          dataIndex: 'date',
          title: '日期'
        },
        {
          dataIndex: 'channel',
          title: '渠道'
        },
        {
          dataIndex: 'country',
          title: '国家'
        },
        {
          dataIndex: 'spend',
          title: '消耗'
        },
        {
          dataIndex: 'install',
          title: '安装'
        },
      ]
      this._export_cvs(_data_list, _data_field, _name)
    },
    changeCountry() {
      if (this.addForm.country.includes('ALL')) {
        this.addForm.country = ['ALL']
      }
      let _list = {}
      this.addForm.country.forEach(country => {
        if (this.addForm.country_list[country]) {
          _list[country] = this.addForm.country_list[country]
        } else {
          _list[country] = {
            country: country,
            spend: 0,
            installs: 0,
          }
        }
      })
      this.addForm.country_list = _list
    },
    removeCountry(country) {
      let _index = this.addForm.country.findIndex(item => {
        return item == country
      })
      this.addForm.country.splice(_index, 1)
      delete this.addForm.country_list[country]
    },
    handleOk() {
      AddSpendSelf(this.addForm).then(resp => {
        if (resp.code === 200) {
          this.$message.success(resp.msg)
          this.$emit('close-dialog')
        } else {
          this.$message.error(resp.msg)
        }
      })
    },
    handleCancel() {
      this.$emit('close-dialog')
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/Spend/Self/AddPanel.vue